/*
 * File: CustomPopOver.tsx
 * Project: a-a
 * File Created: Tuesday, 26th November 2024 9:49:03 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 15th July 2025 6:53:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { ReactNode } from 'react';
import Popover from '@mui/material/Popover';
import { styled } from '@mui/material/styles';
import { SxProps, Theme, Typography } from '@mui/material';

const CustomPopOverElement = styled(Popover)(({ theme }) => ({
  '& .MuiPopover-paper': {
    borderRadius: '14px',
    boxShadow: 'rgba(0, 0, 0, 0.15)',
  },
}));

const CustomPopOver = ({
  setAnchorEl,
  anchorEl,
  id,
  children,
  sx,
  vertical,
  horizontal,
  onClick,
}: {
  setAnchorEl:
    | React.Dispatch<React.SetStateAction<SVGSVGElement | null>>
    | React.Dispatch<React.SetStateAction<HTMLImageElement | null>>
    | React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
    | React.Dispatch<React.SetStateAction<HTMLElement | null>>
    | React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
  anchorEl:
    | SVGSVGElement
    | HTMLImageElement
    | HTMLDivElement
    | HTMLElement
    | HTMLButtonElement
    | null;
  id: 'simple-popover' | undefined;
  children: ReactNode;
  sx?: SxProps<Theme> | undefined;
  vertical?: string;
  horizontal?: string;
  onClick?: (e: React.MouseEvent<any>) => void;
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <CustomPopOverElement
      onClick={onClick ? onClick : undefined}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: vertical ? (vertical as number | 'center' | 'bottom' | 'top') : 'bottom',
        horizontal: horizontal ? (horizontal as number | 'center' | 'left' | 'right') : 'left',
      }}
      sx={{ ...sx }}
      //   elevation={0}
      aria-hidden={open ? 'false' : 'true'}
    >
      {children}
    </CustomPopOverElement>
  );
};

export default CustomPopOver;
